module.exports = __webpack_public_path__ + "img/slotmachine_multiplier.46035036.png";